var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.397 1.20473e-06H0.603134C0.377342 -0.000474686 0.170473 0.140071 0.0673229 0.363897C-0.0372498 0.590737 -0.0188962 0.863897 0.114701 1.07107L4.80184 8.4329C4.8034 8.43544 4.80511 8.43782 4.80668 8.44036C4.97698 8.6967 5.06917 9.0073 5.0696 9.3263V15.3284C5.06861 15.506 5.13121 15.6769 5.24346 15.803C5.35586 15.9289 5.50866 16 5.66801 16C5.74897 15.9998 5.82921 15.9819 5.90405 15.9472L8.53786 14.8276C8.77375 14.7471 8.9304 14.4989 8.9304 14.2V9.3263C8.93083 9.0073 9.02302 8.6967 9.19318 8.44036C9.19475 8.43782 9.19646 8.43544 9.19802 8.4329L13.8853 1.07091C14.0189 0.863897 14.0372 0.590896 13.9327 0.364056C13.8297 0.140071 13.6227 -0.000474686 13.397 1.20473e-06Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7d23f521.svg";
export { ForwardRef as ReactComponent };